import { createTheme } from '../create-theme'

export const defaultTheme = createTheme()
